module.exports = __webpack_public_path__ + "img/score-predictor-header.ec55216a.png";